// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin-auto-x {
  margin-right: auto !important;
  margin-left: auto !important;
}

.margin-outlet-x {
  margin-left: 2rem !important;
  margin-right: 2rem !important;
}

.padding-special {
  padding: 0.25rem 0.5rem !important;
}

.margin-none {
  margin: 0px !important;
}

.padding-circle {
  padding: 10px 5px !important;
}

.margin-top-none {
  margin-top: 0px !important;
}

.margin-top-0 {
  margin-top: 0.6rem !important;
}

.margin-top-0-2 {
  margin-top: 0.2rem !important;
}

.margin-top-0-8 {
  margin-top: 0.8rem !important;
}

.margin-top-1 {
  margin-top: 1.1rem !important;
}

.margin-top-2 {
  margin-top: 2rem !important;
}

.margin-top-2-5 {
  margin-top: 2.5rem !important;
}

.margin-top-3 {
  margin-top: 3rem !important;
}

.margin-top-4 {
  margin-top: 4rem !important;
}

.margin-top-6 {
  margin-top: 6rem !important;
}

.margin-top-10 {
  margin-top: 10rem !important;
}

.margin-bottom-none {
  margin-bottom: 0px !important;
}

.margin-bottom-0-2 {
  margin-bottom: 0.2rem !important;
}

.margin-bottom-0 {
  margin-bottom: 0.6rem !important;
}

.margin-bottom-1 {
  margin-bottom: 1.1rem !important;
}

.margin-bottom-2 {
  margin-bottom: 2rem !important;
}

.margin-bottom-2-5 {
  margin-bottom: 2.5rem !important;
}

.margin-bottom-3 {
  margin-bottom: 3rem !important;
}

.margin-bottom-4 {
  margin-bottom: 4rem !important;
}

.margin-bottom-5 {
  margin-bottom: 5rem !important;
}

.margin-right-0-1 {
  margin-right: 0.05rem !important;
}

.margin-right-none {
  margin-right: 0px;
}

.margin-right-0 {
  margin-right: 0.6rem !important;
}

.margin-right-1 {
  margin-right: 1.6rem !important;
}

.margin-right-2 {
  margin-right: 2rem !important;
}

.margin-right-3 {
  margin-right: 3rem !important;
}

.margin-left-none {
  margin-left: 0px !important;
}

.margin-left-0-2 {
  margin-left: 0.2rem !important;
}

.margin-left-0 {
  margin-left: 0.6rem !important;
}

.margin-left-1 {
  margin-left: 1.6rem !important;
}

.margin-left-neg-1 {
  margin-left: -1rem !important;
}

.margin-right-neg-1 {
  margin-right: -1rem !important;
}

.margin-left-2 {
  margin-left: 2rem !important;
}

.margin-left-3 {
  margin-left: 3rem !important;
}

.margin-left-4 {
  margin-left: 4rem !important;
}

.padding-none {
  padding: 0px !important;
}

.padding-left-none {
  padding-left: 0px !important;
}

.padding-top-none {
  padding-top: 0px !important;
}

.padding-right-none {
  padding-right: 0px !important;
}

.padding-2 {
  padding: 10px !important;
}

.padding-4 {
  padding: 20px !important;
}

.padding-top-0 {
  padding-top: 0.5rem !important;
}

.padding-top-1 {
  padding-top: 1rem !important;
}

.padding-top-2 {
  padding-top: 2rem !important;
}

.padding-top-3 {
  padding-top: 3rem !important;
}

.padding-top-4 {
  padding-top: 4rem !important;
}

.padding-top-6 {
  padding-top: 6rem !important;
}

.padding-bottom-none {
  padding-bottom: 0px !important;
}

.padding-bottom-0 {
  padding-bottom: 0.5rem !important;
}

.padding-bottom-1 {
  padding-bottom: 1rem !important;
}

.padding-bottom-2 {
  padding-bottom: 2rem !important;
}

.padding-bottom-3 {
  padding-bottom: 3rem !important;
}

.padding-bottom-4 {
  padding-bottom: 4rem !important;
}

.padding-left-0 {
  padding-left: 0.5rem !important;
}

.padding-right-0 {
  padding-right: 0.5rem !important;
}

.padding-left-0-1 {
  padding-left: 0.05rem !important;
}

.padding-left-1 {
  padding-left: 1rem !important;
}

.padding-left-2 {
  padding-left: 2rem !important;
}

.padding-left-3 {
  padding-left: 3rem !important;
}

.padding-left-4 {
  padding-left: 4rem !important;
}

.padding-right-1 {
  padding-right: 1rem !important;
}

.padding-right-2 {
  padding-right: 2rem !important;
}

.padding-right-3 {
  padding-right: 3rem !important;
}

.padding-right-4 {
  padding-right: 4rem !important;
}

.border-black {
  border: 1px solid #000000 !important;
}

.border-solid-orange {
  border: 1px solid #ff8908 !important;
}

.border-primary-active {
  border: 1px solid #ff611d !important;
}

.border-dashed-white {
  border: 1px dashed #fff !important;
}

.border-none {
  border: none !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.border-top {
  border-top: 1px solid #DDE7FF !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.break-word {
  word-break: break-all;
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-hidden-x {
  overflow-x: hidden !important;
}

.overflow-hidden-y {
  overflow-y: hidden !important;
}

.overflow-scroll-x {
  overflow-x: scroll;
}

.overflow-scroll-y {
  overflow-y: scroll;
}

.overflow-auto-x {
  overflow-x: auto;
}

.overflow-auto-y {
  overflow-y: auto;
}

.display-none {
  display: none;
}

.float-right {
  float: right !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.align-middle {
  vertical-align: middle;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.border-top {
  border-top: 1px solid #DDE7FF !important;
}

.text-transform-capitalize {
  text-transform: capitalize !important;
}

.text-underline {
  text-decoration: underline !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.card-dimension {
  width: 100px !important;
  height: 100px !important;
}

.display-block {
  display: block;
}

.height-inherit {
  height: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/utilities.scss"],"names":[],"mappings":"AAIA;EACE,6BAAA;EACA,4BAAA;AADF;;AAIA;EACE,4BAAA;EACA,6BAAA;AADF;;AAIA;EACE,kCAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,4BAAA;AADF;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,4BAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,8BAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAMA;EACE,iBAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,6BAAA;AAHF;;AAMA;EACE,6BAAA;AAHF;;AAOA;EACE,2BAAA;AAJF;;AAQA;EACE,8BAAA;AALF;;AASA;EACE,8BAAA;AANF;;AASA;EACE,8BAAA;AANF;;AASA;EACE,6BAAA;AANF;;AASA;EACE,8BAAA;AANF;;AASA;EACE,4BAAA;AANF;;AASA;EACE,4BAAA;AANF;;AASA;EACE,4BAAA;AANF;;AAWA;EACE,uBAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,2BAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,wBAAA;AARF;;AAWA;EACE,wBAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,iCAAA;AARF;;AAWA;EACE,+BAAA;AARF;;AAWA;EACE,+BAAA;AARF;;AAWA;EACE,+BAAA;AARF;;AAWA;EACE,+BAAA;AARF;;AAWA;EACE,+BAAA;AARF;;AAWA;EACE,gCAAA;AARF;;AAWA;EACE,gCAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAWA;EACE,8BAAA;AARF;;AAYA;EACE,oCAAA;AATF;;AAaA;EACE,oCAAA;AAVF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,kCAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAgBA;EACE,0BAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,wCAAA;AAbF;;AAiBA;EACE,4BAAA;AAdF;;AAiBA;EACE,qBAAA;AAdF;;AAiBA;EACE,cAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EACE,6BAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,uBAAA;AAdF;;AAkBA;EACE,0BAAA;AAfF;;AAkBA;EACE,8BAAA;AAfF;;AAkBA;EACE,sBAAA;AAfF;;AAkBA;EACE,6BAAA;AAfF;;AAkBA;EACE,6BAAA;AAfF;;AAkBA;EACE,wCAAA;AAfF;;AAkBA;EACE,qCAAA;AAfF;;AAkBA;EACE,qCAAA;AAfF;;AAkBA;EACE,4BAAA;AAfF;;AAkBA;EACE,uBAAA;EACA,wBAAA;AAfF;;AAkBA;EACE,cAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF","sourcesContent":["@import \"./variables\";\n\n//margins\n\n.margin-auto-x {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.margin-outlet-x {\n  margin-left: 2rem !important;\n  margin-right: 2rem !important;\n}\n\n.padding-special {\n  padding: 0.25rem 0.5rem !important;\n}\n\n.margin-none {\n  margin: 0px !important;\n}\n\n.padding-circle {\n  padding: 10px 5px !important;\n}\n\n.margin-top-none {\n  margin-top: 0px !important;\n}\n\n.margin-top-0 {\n  margin-top: .6rem !important;\n}\n\n.margin-top-0-2 {\n  margin-top: .2rem !important;\n}\n\n.margin-top-0-8 {\n  margin-top: .8rem !important;\n}\n\n.margin-top-1 {\n  margin-top: 1.1rem !important;\n}\n\n.margin-top-2 {\n  margin-top: 2rem !important;\n}\n\n.margin-top-2-5 {\n  margin-top: 2.5rem !important;\n}\n\n\n.margin-top-3 {\n  margin-top: 3rem !important;\n}\n\n.margin-top-4 {\n  margin-top: 4rem !important;\n}\n\n.margin-top-6 {\n  margin-top: 6rem !important;\n}\n\n.margin-top-10 {\n  margin-top: 10rem !important;\n}\n\n.margin-bottom-none {\n  margin-bottom: 0px !important;\n}\n\n.margin-bottom-0-2 {\n  margin-bottom: .2rem !important;\n}\n\n.margin-bottom-0 {\n  margin-bottom: 0.6rem !important;\n}\n\n.margin-bottom-1 {\n  margin-bottom: 1.1rem !important;\n}\n\n.margin-bottom-2 {\n  margin-bottom: 2rem !important;\n}\n\n.margin-bottom-2-5 {\n  margin-bottom: 2.5rem !important;\n}\n\n.margin-bottom-3 {\n  margin-bottom: 3rem !important;\n}\n\n.margin-bottom-4 {\n  margin-bottom: 4rem !important;\n}\n\n.margin-bottom-5 {\n  margin-bottom: 5rem !important;\n}\n\n.margin-right-0-1 {\n  margin-right: 0.05rem !important;\n}\n\n\n.margin-right-none {\n  margin-right: 0px;\n}\n\n.margin-right-0 {\n  margin-right: 0.6rem !important;\n}\n\n.margin-right-1 {\n  margin-right: 1.6rem !important;\n}\n\n.margin-right-2 {\n  margin-right: 2rem !important;\n}\n\n.margin-right-3 {\n  margin-right: 3rem !important;\n}\n\n\n.margin-left-none {\n  margin-left: 0px !important;\n}\n\n\n.margin-left-0-2 {\n  margin-left: .2rem !important;\n}\n\n\n.margin-left-0 {\n  margin-left: 0.6rem !important;\n}\n\n.margin-left-1 {\n  margin-left: 1.6rem !important;\n}\n\n.margin-left-neg-1 {\n  margin-left: -1rem !important;\n}\n\n.margin-right-neg-1 {\n  margin-right: -1rem !important;\n}\n\n.margin-left-2 {\n  margin-left: 2rem !important;\n}\n\n.margin-left-3 {\n  margin-left: 3rem !important;\n}\n\n.margin-left-4 {\n  margin-left: 4rem !important;\n}\n\n//padding\n\n.padding-none {\n  padding: 0px !important;\n}\n\n.padding-left-none {\n  padding-left: 0px !important;\n}\n\n.padding-top-none {\n  padding-top: 0px !important;\n}\n\n.padding-right-none {\n  padding-right: 0px !important;\n}\n\n.padding-2 {\n  padding: 10px !important;\n}\n\n.padding-4 {\n  padding: 20px !important;\n}\n\n.padding-top-0 {\n  padding-top: 0.5rem !important;\n}\n\n.padding-top-1 {\n  padding-top: 1rem !important;\n}\n\n.padding-top-2 {\n  padding-top: 2rem !important;\n}\n\n.padding-top-3 {\n  padding-top: 3rem !important;\n}\n\n.padding-top-4 {\n  padding-top: 4rem !important;\n}\n\n.padding-top-6 {\n  padding-top: 6rem !important;\n}\n\n.padding-bottom-none {\n  padding-bottom: 0px !important;\n}\n\n.padding-bottom-0 {\n  padding-bottom: 0.5rem !important;\n}\n\n.padding-bottom-1 {\n  padding-bottom: 1rem !important;\n}\n\n.padding-bottom-2 {\n  padding-bottom: 2rem !important;\n}\n\n.padding-bottom-3 {\n  padding-bottom: 3rem !important;\n}\n\n.padding-bottom-4 {\n  padding-bottom: 4rem !important;\n}\n\n.padding-left-0 {\n  padding-left: 0.5rem !important;\n}\n\n.padding-right-0 {\n  padding-right: 0.5rem !important;\n}\n\n.padding-left-0-1 {\n  padding-left: 0.05rem !important;\n}\n\n.padding-left-1 {\n  padding-left: 1rem !important;\n}\n\n.padding-left-2 {\n  padding-left: 2rem !important;\n}\n\n.padding-left-3 {\n  padding-left: 3rem !important;\n}\n\n.padding-left-4 {\n  padding-left: 4rem !important;\n}\n\n.padding-right-1 {\n  padding-right: 1rem !important;\n}\n\n.padding-right-2 {\n  padding-right: 2rem !important;\n}\n\n.padding-right-3 {\n  padding-right: 3rem !important;\n}\n\n.padding-right-4 {\n  padding-right: 4rem !important;\n}\n\n\n.border-black {\n  border: 1px solid $black-color !important;\n}\n\n\n.border-solid-orange {\n  border: 1px solid $orange-color !important;\n}\n\n\n.border-primary-active {\n  border: 1px solid $primary-color !important;\n}\n\n.border-dashed-white {\n  border: 1px dashed #fff !important;\n}\n\n.border-none {\n  border: none !important;\n}\n\n\n//others\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n.border-top {\n  border-top: 1px solid #DDE7FF !important;\n}\n\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.break-word {\n  word-break: break-all;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-hidden-x {\n  overflow-x: hidden !important;\n}\n\n.overflow-hidden-y {\n  overflow-y: hidden !important;\n}\n\n.overflow-scroll-x {\n  overflow-x: scroll;\n}\n\n.overflow-scroll-y {\n  overflow-y: scroll;\n}\n\n.overflow-auto-x {\n  overflow-x: auto;\n}\n\n.overflow-auto-y {\n  overflow-y: auto;\n}\n\n.display-none {\n  display: none;\n}\n\n.float-right {\n  float: right !important;\n}\n\n//others\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n.align-middle {\n  vertical-align: middle;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.border-top {\n  border-top: 1px solid #DDE7FF !important;\n}\n\n.text-transform-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-underline {\n  text-decoration: underline !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.card-dimension {\n  width: 100px !important;\n  height: 100px !important;\n}\n\n.display-block {\n  display: block;\n}\n\n.height-inherit {\n  height: inherit !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
